import EBTPaymentInfoModal from './EBTPaymentInfoModal';

export default EBTPaymentInfoModal;
